<template>
  <div id="all" class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card no-body>
          <b-card-body>
            <template>
              <b-row>
                <b-col sm="3">
                  <b-form-group label-for="date" label="Tanggal Aktual">
                    <v-date-picker
                      mode='range'
                      id="date"
                      :input-props="{ class: 'form-control', placeholder: 'Tanggal Aktual', required: '', readonly: ''}"
                      v-model="myDate"
                    ></v-date-picker>
                  </b-form-group>
                </b-col>

                <b-col sm="3">
                  <b-form-group label-for="month" label="Penanggung Jawab Faktur">
                    <b-form-select
                      id="pic"
                      v-model="pic"
                      required
                    >
                      <template slot="first">
                        <option :value="null" disabled>-- Harap pilih salah satu --</option>
                      </template>
                      <option
                        v-for="(item, index) in listDriverEmployee"
                        :key="uniqueId('employee_list'+index)"
                        :value="{code:'employee', value:item.value}"
                      >{{item.text}}</option>
                      <option
                        v-for="(item, index) in listDistributionCenter"
                        :key="uniqueId('dc_list'+index)"
                        :value="{code:'distribution_center', value:item.value}"
                      >{{item.text}}</option>
                    </b-form-select>
                    <b-form-invalid-feedback>Penanggung jawab faktur harus di pilih.</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <!-- <b-col sm="3">
                  <b-form-group label-for="month" label="Bulan">
                    <model-select
                      id="month"
                      :options="listMonth"
                      v-model="month"
                      placeholder="Bulan"
                    ></model-select>
                  </b-form-group>
                </b-col>

                <b-col sm="3">
                  <b-form-group label-for="year" label="Tahun">
                    <model-select
                      id="year"
                      :options="listYear"
                      v-model="year"
                      placeholder="Tahun"
                    ></model-select>
                  </b-form-group>
                </b-col> -->

                 <b-col sm="3">
                  <b-form-group label-for="type" label="SPKB Type">
                    <model-select
                      id="type"
                      :options="listSpkbType"
                      v-model="spkbType"
                      placeholder="SPKB Type"
                    ></model-select>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col lg="12">
                  <b-button
                    size="sm"
                    variant="stack-overflow"
                    class="mr-1 btn-brand"
                    @click="getDataPiutang"
                  >
                    <i class="fa fa-search"></i>
                    <span>Filter</span>
                  </b-button>
                </b-col>
              </b-row>
            </template>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>


    <b-card>
      <b-row>
        <b-col sm="5">
          <h4 id="traffic" class="card-title mb-0">Jumlah Piutang {{(spkbType === '1' ? 'Cash' : 'Tempo')}}</h4>
          <div class="small text-muted">
            Based On Actual Time 
          </div>
        </b-col>
      </b-row>

      <template v-if="!loading">
        <table class="rekap-ro table-bordered table-responsive">
          <thead>
            <tr>
              <th rowspan="3" class="width-250">SPKB</th>
              <th rowspan="3" class="width-250">Tanggal Aktual</th>
              <th colspan="6" class="width-250">Total</th>
              <th rowspan="3" class="width-250">Action</th>
            </tr>
             <tr>
              <th colspan="2" class="width-300">Aktual</th>
              <th colspan="2" class="width-300">Retur</th>
              <th colspan="2" class="width-300">BPB</th>
            </tr>
            <tr>
              <th>Qty</th>
              <th>Total</th>
              <th>Qty</th>
              <th>Total</th>
              <th>Qty</th>
              <th>Total</th>
            </tr>
          </thead>

          <tbody v-if="dataPiutang.length > 0">
            <tr>
              <td colspan="2" style="text-align: right;">Total Summary</td>
              <td>{{formatPrice(totalQtyActual)}}</td>
              <td>{{formatPrice(totalPriceActual)}}</td>
              <td>{{formatPrice(totalQtyRetur)}}</td>
              <td>{{formatPrice(totalPriceRetur)}}</td>
              <td>{{formatPrice(totalQtyBpb)}}</td>
              <td>{{formatPrice(totalPriceBpb)}}</td>
              <td>&nbsp;</td>
            </tr>
            <template v-for="(v, index) in dataPiutang">
              <tr :key="uniqueId(index+'B')">
                <td>{{v.spkb_number}}</td>
                <td>{{dateTimeFormat(v.actual_update_time)}}</td>
                <td>{{formatPrice(v.total_qty_actual)}}</td>
                <td>{{formatPrice(v.total_price_actual)}}</td>
                <td>{{formatPrice(v.total_qty_retur)}}</td>
                <td>{{formatPrice(v.total_price_retur)}}</td>
                <td>{{(v.flag_bpb !== 'not-set') ? formatPrice(v.total_qty_bpb) : 'Not Set'}}</td>
                <td>{{(v.flag_bpb !== 'not-set') ? formatPrice(v.total_price_bpb) : 'Not Set'}}</td>
                <td> <b-button
                      v-if="v.flag_bpb !== 'not-set'"
                      type="button"
                      @click="viewBpBDetail(v.spkb_number)"
                      size="sm"
                      variant="link"
                    >
                      <i class="cui-note icons"></i> View bpb
                    </b-button></td>
              </tr>
            </template>
          </tbody>

          <tbody v-else>
             <tr>
               <td colspan="9">No Data Available</td>
             </tr>
          </tbody>

        </table>
      </template>
      
      <loading v-else></loading>
    </b-card>

     <b-row>
      <b-modal
        ref="myModalRef"
        id="addModals"
        header-border-variant="no-border text-center"
        footer-border-variant="no-border"
        footer-bg-variant="light"
        :no-close-on-backdrop="true"
        :no-close-on-esc="true"
        size="xl"
      >
        <div slot="modal-header" class="text-center">
          <h3 class="text-center">Show BPB Final {{spkbNumber}}</h3>
        </div>

        <div v-if="loadingSubmit">
          <loading></loading>
        </div>

        <b-form id="mitraCoverageForm" validated novalidate>
          <div v-if="!loadingSubmit">
            <bpb-detail
              :spkb-number="spkbNumber"
              :loading-submit="loadingSubmit"
            ></bpb-detail>
          </div>
        </b-form>

        <div slot="modal-footer" class="float-right">
          <div v-if="!loadingSubmit">
            <b-button type="button" size="sm" variant="danger" @click="cancelAdd">
              <i class="fa fa-undo"></i> Back
            </b-button>&nbsp;
          </div>
        </div>
      </b-modal>
    </b-row>
  </div>
</template>


<script>
import { Callout } from "@coreui/vue";
import axios from "axios";
import globalTable from "@/templates/Table.vue";
import VueNotifications from "vue-notifications";
import loading from "@/templates/Loading.vue";
import DoughnutExample from "@/views/charts/DoughnutExample.vue";
import LineExample from "@/views/charts/LinePriceExample.vue";
import BarExample from "@/views/charts/BarExample.vue";
import * as moment from "moment";
import { ModelSelect } from "vue-search-select";
import bpbDetail from "./BpbDetail.vue";

import _ from "lodash";
export default {
  name: "dashboard-piutang-customer",
  components: {
    ModelSelect,
    globalTable,
    Callout,
    loading,
    LineExample,
    DoughnutExample,
    BarExample,
    bpbDetail
  },
  props: {
    tableDetail: {
      type: Boolean,
      default: true,
    },
  },
  data: function () {
    return {
      employee: [],
      loading: true,
      currentYear: moment().format("YYYY"),
      currentMonth: moment().format("MMMM"),
      today: moment().format("DD"),
      year: moment().format("YYYY"),
      month: moment().format("MM"),
      myDate: null,
      pic: null,
      spkbType: '2',
      listSpkbType: [
        {value: '1', text: 'Cash'},
        {value: '2', text: 'Tempo'},
      ],
      listMonth: [],
      listYear: [],
      dataPiutang: [],
      loadingSubmit: true,
      spkbNumber: null,
      listDriverEmployee: [],
      listDistributionCenter: [],
    };
  },
computed: {
    isMobile: function() {
        let check = false;
        (function(a) {
            if (
            /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
                a
            ) ||
            /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
                a.substr(0, 4)
            )
            )
            check = true;
        })(navigator.userAgent || navigator.vendor || window.opera);
        if (check === true) {
            if (window.screen.width < 732) {
            return undefined;
            } else {
            return 100;
            }
        } else {
            return 100;
        }
    }
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  computed: {
    totalQtyActual: function(){
      let t = 0;
      for (let i of this.dataPiutang) {
        t += parseInt(i.total_qty_actual);
      }
      return t;
    },
    totalQtyRetur: function(){
      let t = 0;
      for (let i of this.dataPiutang) {
        t += parseInt(i.total_qty_retur);
      }
      return t;
    },
    totalQtyBpb: function(){
      let t = 0;
      for (let i of this.dataPiutang) {
        t += parseInt(i.total_qty_bpb);
      }
      return t;
    },
    totalPriceActual: function(){
      let t = 0;
      for (let i of this.dataPiutang) {
        t += parseInt(i.total_price_actual);
      }
      return t;
    },
    totalPriceRetur: function(){
      let t = 0;
      for (let i of this.dataPiutang) {
        t += parseInt(i.total_price_retur);
      }
      return t;
    },
    totalPriceBpb: function(){
      let t = 0;
      for (let i of this.dataPiutang) {
        t += parseInt(i.total_price_bpb);
      }
      return t;
    }
  },
  methods: {
    uniqueId: function (param = "") {
      return _.uniqueId(param);
    },
    init: function () {
      this.loading = true;
      this.dropdown();
      this.getDropdownSpkb();
      this.currentYear = moment(this.year + "-" + this.month + "-01").format(
        "YYYY"
      );
      this.currentMonth = moment(this.year + "-" + this.month + "-01").format(
        "MMMM"
      );
      //this.getDataPiutang();
    },
    dropdown: function () {
      this.axios
        .get("web/dropdown/dashboard-cro/")
        .then((response) => {
          this.listMonth = response.data.month;
          this.listYear = response.data.year;
          //   this.listEmployee = response.data.employee;
          //   this.listCustomerGroup = response.data.customer_group;
          //   this.listProductGroup = response.data.products_group;
          //   this.listFlagWeekOrder = response.data.flag_week_order;
        })
        .catch((error) => {})
        .finally(() => {
          this.loading = false;
        });
    },
    getDropdownSpkb: function() {
      this.axios
        .get("web/dropdown/dropdown-spkb/")
        .then(response => {
          this.listDriverEmployee = response.data.driver;
          this.listDistributionCenter = response.data.distribution_center;
          // this.listCustomerHoreka = response.data.customer_horeka;
          // this.listBank = response.data.bank;
        })
        .catch(error => {})
        .finally(() => {
          //this.loading = false;
        });
    },
    getDataPiutang: function() {
      if(this.myDate === null) {
        alert('Tanggal Harus di pilih');
      } else if(this.pic === null) {
        alert('Penanggung Jawab Faktur Harus di pilih');
      }else {
        let start = moment(this.myDate.start).format("YYYY-MM-DD");
        let end = moment(this.myDate.end).format("YYYY-MM-DD");
        this.loading = true;
          this.axios
          .post( "web/dashboard/customer_piutang/all-piutang", {start_date: start, end_date: end, type: this.spkbType, pic: this.pic})
          .then(response => {
            this.dataPiutang = response.data.data;
          })
          .catch(error => {})
          .finally(() => {
            this.loading = false;
          });
      }
    },
    viewBpBDetail: function(spkb) {
      this.spkbNumber = spkb;
      this.loadingSubmit = false;
      this.$refs.myModalRef.show();
      console.log(spkb);
    },
    cancelAdd: function() {
      this.$refs.myModalRef.hide();
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(0).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
     dateTimeFormat: function (date) {
      return moment(date).format("DD MMM YYYY HH:mm:ss");
    },
  },
  mounted() {
    this.init();
  },
};
</script>


<style>
</style>